import { useEffect, useState } from "react";
import { useOrder } from "store";

export const useSkipSurveyScheduleOnboarding = (
  handleNext: () => Promise<void>
) => {
  const order = useOrder();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!order) return;
    if (order.hasScheduledSurveyService) {
      handleNext();
    } else {
      setLoading(false);
    }
  }, [order]);

  return loading;
};
